import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaixaGerenciarListarRoutingModule } from './caixa-gerenciar-listar-routing.module';
import { CaixaGerenciarListarComponent } from './caixa-gerenciar-listar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    CaixaGerenciarListarComponent
  ],
  imports: [
    CommonModule,
    CaixaGerenciarListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    CalendarModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    DialogModule,
    TooltipModule,
    ProgressSpinnerModule
  ]
})
export class CaixaGerenciarListarModule { }
